import * as siteRouters from './';

const allRouters = Object.keys(siteRouters).reduce((acc, cur) => {
    // 在開發環境中才載入 DevelopmentRouter
    if (cur === 'DevelopmentRouter' && process.env.NODE_ENV !== 'development') {
        return acc;
    }
    return [...acc, ...siteRouters[cur]];
}, []);

const routerMap = [...allRouters];

export default routerMap;
